<template>
  <section class="d-system">
    <div class="d-system__banner">
      <TopBanner class="mb-16" :item="banner" />
    </div>

    <div
      class="container _py-16 _py-md-12 _px-md-4"
      v-if="getDistributionList !== null"
    >
      <AppBtnBreadCrumb class="_mb-4" />
      <div class="sections__list d-grid row-1-1 gap-32">
        <VideoCard
          :simple="true"
          @viewItem="viewItem"
          @like="like"
          @favorite="favorite"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in getDistributionList"
          :key="ind"
          :item="getTranslate(block)"
          :analyticEventPrefix="'distribution_material'"
        >
          <!-- <template v-slot:button>
            <AppBtn class="_mt-4 _ml-md-4">
              <a
                :href="getTranslate(block).link"
                target="_blank"
                class="_py-4 _px-6"
              >
                <span class="_fs-16 _tc-white">Пройти тест</span>
              </a>
            </AppBtn>
          </template> -->
        </VideoCard>
      </div>
    </div>
    <div class="d-flex justify-center _my-6" v-else>
      <Preloader />
    </div>
    <div class="_bg-light">
      <OtherMain :items="sectionsList" :analyticEventPrefix="'distribution_'">
        <template v-slot:title>
          <div
            class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
          >
            {{ $t("another_sections_title") }}
          </div>
        </template>
      </OtherMain>
    </div>
  </section>
</template>

<script>
import TopBanner from "@/components/UI/banners/TopBanner";
// import AppBtn from '@/components/UI/buttons/AppBtn'
import VideoCard from "@/components/UI/cards/VideoCard";
import Preloader from "@/components/UI/Preloader";
import AppBtnBreadCrumb from "@/components/UI/buttons/AppBtnBreadCrumb";
import OtherMain from "@/components/UI/OtherMain";
import download from "@/mixins/download";

import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.system") };
  },
  name: "System",
  components: {
    TopBanner,
    // AppBtn,
    VideoCard,
    AppBtnBreadCrumb,
    OtherMain,
    Preloader,
  },
  mixins: [download],
  data: () => ({}),
  computed: {
    ...mapGetters(["getDistributionList", "Sections"]),
    sectionsList() {
      const vm = this;
      return this.$t("another_sections") &&
        Array.isArray(this.$t("another_sections"))
        ? this.$t("another_sections")
            .filter((el) => !el.hide)
            .map(function (el) {
              return {
                ...el,
                image: require(`@/assets/img/sections/${el.image}`),
                route: vm.helpers.buildRoute(el.route),
              };
            })
        : null;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    banner() {
      return {
        title: this.$t("pages.system.title"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/system/DS-mob.jpg"),
            media: "(max-width: 743px)",
          },
          {
            src: require("@/assets/img/banners/system/DS-tab.jpg"),
            media: "(max-width: 1220px)",
          },
          {
            src: require("@/assets/img/banners/system/DS-1440.jpg"),
            media: "(max-width: 1919px)",
          },
          {
            src: require("@/assets/img/banners/system/DS-1920.jpg"),
            media: "(min-width: 1920px)",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchDistributionList",
      "DistributionSetVideoProgress",
      "DistributionSetLike",
      "DistributionSetFavorite",
      "DistributionSetView",
    ]),
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file,
        link: item.translates[0].link,
        file_size: item.translates[0].file_size,
        extras: item.translates[0].extras,
      };
    },
    async updateList() {
      await this.fetchDistributionList(this.currentLocale);
    },
    async like(id) {
      await this.DistributionSetLike(id);
      await this.updateList();
    },
    async favorite(id) {
      await this.DistributionSetFavorite(id);
      await this.updateList();
    },
    async setVideoProgress(id, time) {
      await this.DistributionSetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.DistributionSetView(id);
      await this.updateList();
    },
  },
  async mounted() {
    await this.fetchDistributionList(this.currentLocale);
  },
};
</script>

<style lang="scss">
.d-system {
  &__banner {
    background-color: #EEF3F7;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>
